import { render } from "./promo-100k.vue?vue&type=template&id=844786b8"
import script from "./promo-100k.js?vue&type=script&lang=js&external"
export * from "./promo-100k.js?vue&type=script&lang=js&external"

import "./promo-100k.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__